<template>
  <transition name="modal-fade">
    <span v-show="filters.isModalVisible">
      <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header" id="modalTitle">
          <slot name="header">
            {{ i18nJS.domestics_massive_registrations.massive_interview }}
            <button type="button" class="btn-close" @click="close" aria-label="Close modal">
              <i class="fa-light fa-xmark"></i>
            </button>
          </slot>
        </header>
        <section class="modal-body" id="modalDescription">
          <slot name="body">
            <div>
              <datepicker class="input_date" :placeholder="i18nJS.from" v-model="filters.dateFrom" required="required" />
              <datepicker class="input_date" :placeholder="i18nJS.to" v-model="filters.dateTo" required="required" />
              <v-select2
                :value="filters['userSelect']"
                :element_id.sync="filters['userSelect']"
                :multiple="false"
                :data-placeholder="i18nJS.user_label"
                data-ajax--url="/it/users?type=presents"
                data-minimumInputLength="0"
                data-pageLimit="20"
                data-allow-clear="true"
              >
              </v-select2>
              <v-select2
                :value="filters['activitySelect']"
                :element_id.sync="filters['activitySelect']"
                :multiple="false"
                :data-placeholder="i18nJS.activities"
                :data-ajax--url="activityAjaxUrl"
                data-minimumInputLength="0"
                data-pageLimit="20"
                data-allow-clear="true"
              >
              </v-select2>
              <v-select2
                :value="filters['guestBusinessUnitSelect']"
                :element_id.sync="filters['guestBusinessUnitSelect']"
                :multiple="false"
                :selectConfig="getConfigGuests()"
                data-allow-clear="true"
              >
              </v-select2>
              <i id="search-icon" class="far fa-magnifying-glass" @click="loadActivity" />
              <i v-if="loading" class="far fa-spinner fa-spin" />
              <br />
              <div v-if="filters.kmRimborsoShow" class="km_rimborso">
                Km Rimborso
                <input type="number" v-model.number="filters.kmRimborso" />
              </div>
              <span v-if="errorDate" class="span-error">
                {{ i18nJS.domestics_massive_registrations.error_message }}
              </span>
              <div v-if="overlapseAlertText !== null" class="alert alert-error">{{ overlapseAlertText }}</div>
              <div v-if="filters.domesticActivities.length">
                <table class="table fixed_header" id="tableDomesticActivities" ref="tableDomesticActivities">
                  <thead>
                    <tr class="heading">
                      <th>{{ i18nJS.activity_row.save }} <i class="far fa-square-check" @click="uncheckSave" /></th>
                      <th>{{ i18nJS.activity_row.date_time_start }} <i class="far fa-sort" @click="visitDateSort" /></th>
                      <th>{{ i18nJS.activity_row.date_time_end }}</th>
                      <th>{{ i18nJS.activity_row.guest }} <i class="far fa-sort" @click="visitUserSort" /></th>
                      <th>{{ i18nJS.activity_row.activity }}</th>
                      <th>{{ i18nJS.activity_row.user }}</th>
                      <th>{{ i18nJS.motivation }}</th>
                      <th>{{ i18nJS.activity_row.duration }}</th>
                      <th>{{ i18nJS.activity_row.km_fatt }}</th>
                      <th v-if="disable_parallel_activity_execution_on_operator === 'true'">Sovrapposizione</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(activity, index) in slicedDomesticActivities"
                      :key="activity.domestic_activity_id"
                      :class="index === slicedDomesticActivities.length - 1 ? checkIfVForIsComplete() : null"
                    >
                      <td>
                        <input
                          type="checkbox"
                          v-model="activity.domestic_activity_save"
                          :disabled="!editable(activity.domestic_activity_id) || !canEdit"
                        />
                      </td>
                      <td>
                        <datepicker
                          :disabled="!canEdit"
                          :placeholder="i18nJS.from"
                          v-model="activity.domestic_activity_date_start"
                          @input="() => updateDuration(activity)"
                          required="required"
                        />
                        <timepicker
                          v-model="activity.domestic_activity_time_start"
                          :disabled="!canEdit"
                          @input="() => updateDuration(activity)"
                        />
                      </td>
                      <td>
                        <datepicker
                          :disabled="!canEdit"
                          :placeholder="i18nJS.from"
                          v-model="activity.domestic_activity_date_end"
                          @input="() => updateDuration(activity)"
                          required="required"
                        />
                        <timepicker
                          v-model="activity.domestic_activity_time_end"
                          :disabled="!canEdit"
                          @input="() => updateDuration(activity)"
                        />
                      </td>
                      <td>{{ activity.domestic_activity_guest }}</td>
                      <td>
                        <v-select2
                          :element_id.sync="activity.domestic_activity_act_conf_id"
                          :multiple="false"
                          :disabled="!canEdit"
                          :data-placeholder="activity.domestic_activity_desc"
                          :data-ajax--url="activityAjaxUrl"
                          data-minimumInputLength="0"
                          data-pageLimit="20"
                          data-allow-clear="true"
                          @input="() => loadMotivations(activity)"
                        >
                        </v-select2>
                      </td>
                      <td>
                        <v-select2
                          :element_id.sync="activity.domestic_activity_user_id"
                          :multiple="false"
                          :disabled="!canEdit || siatEnabled"
                          :data-placeholder="activity.domestic_activity_user"
                          data-ajax--url="/it/users?type=presents"
                          data-minimumInputLength="0"
                          data-pageLimit="20"
                          data-allow-clear="true"
                        >
                        </v-select2>
                      </td>
                      <td>
                        <v-select2
                          :key="activity.domestic_activity_act_conf_id"
                          :element_id.sync="activity.domestic_activity_motivation"
                          :value="activity.domestic_activity_motivation"
                          :multiple="false"
                          :disabled="!canEdit"
                          :data-placeholder="activity.domestic_activity_motivation"
                          :options-list="activity.domestic_activity_motivations"
                          data-minimumInputLength="0"
                          data-pageLimit="20"
                          data-allow-clear="true"
                        >
                        </v-select2>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model.number="activity.domestic_activity_duration"
                          :disabled="!canEdit"
                          @change="() => updateEnd(activity)"
                        />
                      </td>
                      <td><input type="number" v-model.number="activity.domestic_activity_km" /></td>
                      <td class="text-center">
                        <i
                          v-if="disable_parallel_activity_execution_on_operator === 'true' && activity.overlaps"
                          class="fa-light fa-triangle-exclamation js-tooltip"
                          data-title="L'attività si sovrappone ad un'altra."
                        />
                        <i
                          v-if="disable_parallel_activity_execution_on_operator === 'true' && !editable(activity.domestic_activity_id)"
                          class="fa-light fa-triangle-exclamation js-tooltip"
                          data-title="L'attività si sovrappone ad un'altra."
                        />
                      </td>
                    </tr>
                    <tr v-if="showLoader()">
                      <td colspan="8" class="text-center"><i class="far fa-spinner fa-spin" id="loader" ref="loader" /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else id="no-visit">
                {{ i18nJS.no_activity }}
              </div>
            </div>
          </slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-primary secondary" @click="close" aria-label="Close modal">
              {{ i18nJS.command.close }}
            </button>
            <button
              type="button"
              @click="validateActivities"
              :disabled="massiveFormInvalid"
              class="btn btn-success"
              aria-label="Save modal"
            >
              {{ i18nJS.command.save }}
            </button>
          </slot>
        </footer>
      </div>
      <div class="modal-backdrop"></div>
    </span>
  </transition>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import vSelect2 from '../vSelect2';
import datepicker from '../datepicker';
import timepicker from '../timepicker';
import { isVisibleAfter } from '§/mixin/commonMixins.js';

const formEmptyFilters = () => ({
  isModalVisible: false,
  usersUp: false,
  dateUp: false,
  userSelect: '',
  guestBusinessUnitSelect: '',
  activitySelect: null,
  kmRimborso: 0,
  kmRimborsoShow: false,
  dateFrom: null,
  dateTo: null,
  domesticActivities: [], // eg. [{domestic_activity_date_start: ..., domestic_activity_desc: ..., domestic_activity_duration:...,}, ...]
});
export default {
  name: 'massiveRegistrations',
  components: {
    datepicker,
    timepicker,
    vSelect2,
  },
  mixins: [isVisibleAfter],
  props: [
    'siatSendActivitiesUrl',
    'siatEnabled',
    'canEdit',
    'targetModal',
    'domesticActivitiesOverlapsUrl',
    'domesticActivitiesUrl',
    'saveDomesticActivitiesUrl',
    'disable_parallel_activity_execution_on_operator',
  ],
  computed: {
    massiveFormInvalid() {
      return (
        !this.filters.dateFrom ||
        !this.filters.dateTo ||
        !moment(this.filters.dateFrom, 'DD/MM/YYYY', true).isValid() ||
        !moment(this.filters.dateTo, 'DD/MM/YYYY', true).isValid()
      );
    },
    i18nJS() {
      return window.i18nJS;
    },
    activityAjaxUrl() {
      return `/${window.locale}/activities_configs`;
    },
  },
  data() {
    return {
      loading: false,
      errorDate: false,
      filters: formEmptyFilters(),
      startRendering: 0,
      deltaRendering: 10,
      limitRendering: 10,
      slicedDomesticActivities: [],
      guestBusinessUnitsOptionsList: [],
      all_users_ids: [],
      activities_with_overlaps: [],
      overlappingActivitiesExist: null,
      findingParallelActivities: false,
      gad_ids: [],
      allActivitiesCounter: 0,
      invalidActivities: [],
      invalidActivitiesGroups: [],
      overlapseAlertText: null,
    };
  },
  created() {},
  mounted() {
    this.errorDate = false;
    $('#search-icon').mousedown((e) => {
      $('#search-icon').toggleClass('graycolor');
    });
    $('#search-icon').mouseup((e) => {
      $('#search-icon').toggleClass('graycolor');
    });
    $('.date')
      .datepicker($.datepicker.regional[window.locale])
      .on('change', (evt) => {
        self[evt.target.dataset.fieldName] = evt.target.value;
      });
    $(`[data-toggle='massive-registrations'], [data-target='${this.targetModal}']`).click(() => {
      this.$set(this.filters, 'isModalVisible', true);
      document.getElementById('modalDescription').addEventListener('scroll', () => this.scrollingDomesticActivities());
    });
  },
  methods: {
    getConfigGuests() {
      return {
        placeholder: this.i18nJS.guest_label,
        url: '/it/guests/autocomplete_guest_firstname.json?type[]=presents',
        headers: {
          'HTTP-X-EPERSONAM-BU-ID': window.config.business_unit.id,
        },
        processResults: this.processResultsGuests,
      };
    },
    processResultsGuests(data) {
      if (data) {
        return {
          results: data.map((res) => {
            return { text: res.label, id: res.guest_business_unit_id };
          }),
          pagination: {
            more: data.length === 10,
          },
        };
      } else {
        return {};
      }
    },
    editable(active_id) {
      return !this.invalidActivities.includes(active_id);
    },
    updateEnd(e) {
      const new_date = moment(e.domestic_activity_date_start + e.domestic_activity_time_start, i18nJS.time.formats.aux).add(
        e.domestic_activity_duration,
        'minutes',
      );
      e.domestic_activity_date_end = new_date.format(i18nJS.time.formats.date_only);
      e.domestic_activity_time_end = new_date.format('HH:mm');

      this.compareOverlapse(e);
    },
    updateDuration(e) {
      const end = moment(e.domestic_activity_date_end + e.domestic_activity_time_end, i18nJS.time.formats.aux).diff(
        moment(e.domestic_activity_date_start + e.domestic_activity_time_start, i18nJS.time.formats.aux),
      );
      e.domestic_activity_duration = end / 60000;

      this.compareOverlapse(e);
    },
    close() {
      this.resetElementsViews();
      this.filters.domesticActivities.splice(0, this.filters.domesticActivities.length);
      document.getElementById('modalDescription').removeEventListener('scroll', () => this.scrollingDomesticActivities());
      this.filters = formEmptyFilters();
    },
    loadActivity() {
      if (this.filters.dateFrom != null && this.filters.dateTo != null) {
        this.errorDate = false;
        this.filters.kmRimborsoShow = this.filters.userSelect !== '';
        this.error = false;
        this.loading = true;
        this.resetElementsViews();
        this.gad_ids = [];
        apiConnector()
          .post(this.domesticActivitiesUrl, {
            date_start: this.filters.dateFrom,
            date_end: this.filters.dateTo,
            user: this.filters.userSelect,
            activity: this.filters.activitySelect,
            guest_business_unit: this.filters.guestBusinessUnitSelect,
          })
          .then(({ data }) => {
            data.forEach((activity) => {
              this.gad_ids.push(activity.domestic_activity_id);
              activity.domestic_activity_save = true;
            });
            this.allActivitiesCounter = data.size;
            this.$set(this.filters, 'domesticActivities', data);
            this.addSlicedDomesticActivities();
            if (this.disable_parallel_activity_execution_on_operator === 'true') {
              this.checkOverlaps();
              this.findParallelActivities();
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.error = true;
          });
      } else {
        this.errorDate = true;
      }
    },
    // scarico l'overlapping e imposto a false quelle non salvabili
    checkOverlaps() {
      apiConnector()
        .post(this.domesticActivitiesOverlapsUrl, {
          gad_ids: this.gad_ids,
        })
        .then(({ data }) => {
          if (data.length === 0) return;

          this.invalidActivities = [];
          data.forEach((overlap) => {
            this.invalidActivities.push(overlap.compare_id);
          });
          this.slicedDomesticActivities.forEach((activity) => {
            if (this.invalidActivities.includes(activity.domestic_activity_id)) {
              activity.domestic_activity_save = false;
            }
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    saveActivities() {
      this.error = false;
      Loader.show();
      let toSend = [];
      this.filters.domesticActivities.forEach((act) => {
        if (act.domestic_activity_save) {
          if (
            this.disable_parallel_activity_execution_on_operator === 'true' &&
            this.invalidActivities.includes(act.domestic_activity_id)
          ) {
            act.domestic_activity_save = false;
          } else {
            toSend.push(act);
          }
        }
      });
      const params = {
        savingActivity: toSend,
        kmRimborso: this.filters.kmRimborso,
        userFiltred: this.filters.userSelect,
        date: this.filters.dateTo,
      };
      apiConnector()
        .post(this.saveDomesticActivitiesUrl, params)
        .then(() => {
          if (this.siatEnabled) {
            let urlToSend = this.siatSendActivitiesUrl;
            toSend.forEach((activity) => {
              urlToSend = Utils.addGetParam(urlToSend, 'ids[]', activity.domestic_activity_id, false);
            });
            apiConnector()
              .get(urlToSend)
              .then(({ data }) => {
                window.SidekiqUtils.checkJobStatus(
                  window.asyncUrl.replace('__JOB_ID__', data.job_id),
                  data.job_id,
                  this.statusOK,
                  '',
                  true,
                  5000,
                );
              });
          } else {
            this.statusOK({});
          }
        })
        .catch((err) => {
          alert(i18nJS.domestics_massive_registrations.failure_message + err);
          Loader.hide();
          this.error = true;
        });
    },
    statusOK(data) {
      if (data.errors && data.errors !== '') {
        $('#modal-body-errors p').html('Non è stato possibile salvare le seguenti attività: <br/><ul><li>' + data.errors + '</li></ul>');
        $('#modal-errors').modal('show');
      } else {
        if (this.invalidActivities.length > 0) {
          alert(i18nJS.domestics_massive_registrations.success_message_with_excluded);
        } else {
          alert(i18nJS.domestics_massive_registrations.success_message);
        }
      }
      Loader.hide();
      this.$set(this.filters, 'isModalVisible', false);
      this.resetElementsViews();
      this.filters.domesticActivities.splice(0, this.filters.domesticActivities.length);
      this.filters = formEmptyFilters();
    },
    visitUserSort() {
      this.loading = true;
      this.resetElementsViews();
      if (this.usersUp) {
        this.usersUp = false;
        this.filters.domesticActivities.sort(function (a, b) {
          if (a.domestic_activity_guest < b.domestic_activity_guest) {
            return -1;
          }
          if (a.domestic_activity_guest > b.domestic_activity_guest) {
            return 1;
          }
          return 0;
        });
      } else {
        this.usersUp = true;
        this.filters.domesticActivities.sort(function (a, b) {
          if (a.domestic_activity_guest > b.domestic_activity_guest) {
            return -1;
          }
          if (a.domestic_activity_guest < b.domestic_activity_guest) {
            return 1;
          }
          return 0;
        });
      }
      this.addSlicedDomesticActivities();
    },
    visitDateSort() {
      this.loading = true;
      this.resetElementsViews();
      if (this.dateUp) {
        this.dateUp = false;
        this.filters.domesticActivities.sort(function (a, b) {
          if (a.domestic_activity_date_start < b.domestic_activity_date_start) {
            return -1;
          }
          if (a.domestic_activity_date_start > b.domestic_activity_date_start) {
            return 1;
          }
          return 0;
        });
      } else {
        this.dateUp = true;
        this.filters.domesticActivities.sort(function (a, b) {
          if (a.domestic_activity_date_start > b.domestic_activity_date_start) {
            return -1;
          }
          if (a.domestic_activity_date_start < b.domestic_activity_date_start) {
            return 1;
          }
          return 0;
        });
      }
      this.addSlicedDomesticActivities();
    },
    uncheckSave() {
      this.filters.domesticActivities.forEach((activity) => {
        activity.domestic_activity_save = !activity.domestic_activity_save;
      });
    },
    resetElementsViews() {
      this.startRendering = 0;
      this.deltaRendering = 10;
      this.limitRendering = 10;
      if (this.slicedDomesticActivities.length > 0) {
        this.slicedDomesticActivities.splice(0, this.slicedDomesticActivities.length);
      }
    },
    incrementsLimit() {
      this.loading = true;
      this.startRendering = this.limitRendering;
      this.limitRendering += this.deltaRendering;
      this.addSlicedDomesticActivities();
    },
    addSlicedDomesticActivities() {
      this.slicedDomesticActivities = this.slicedDomesticActivities.concat(
        this.filters.domesticActivities.slice(this.startRendering, this.limitRendering),
      );
    },
    showLoader() {
      return this.slicedDomesticActivities.length < this.filters.domesticActivities.length;
    },
    scrollingDomesticActivities() {
      if (
        this.slicedDomesticActivities.length < this.filters.domesticActivities.length &&
        this.COMMON_isVisibleAfter(this.$refs.loader, this.$refs.tableDomesticActivities)
      ) {
        this.incrementsLimit();
      }
    },
    checkIfVForIsComplete() {
      this.loading = false;
    },
    overlaps(a, b) {
      var a_start = moment(a.domestic_activity_date_start + a.domestic_activity_time_start, i18nJS.time.formats.aux)._d;
      var a_end = moment(a.domestic_activity_date_end + a.domestic_activity_time_end, i18nJS.time.formats.aux)._d;
      var b_start = moment(b.domestic_activity_date_start + b.domestic_activity_time_start, i18nJS.time.formats.aux)._d;
      var b_end = moment(b.domestic_activity_date_end + b.domestic_activity_time_end, i18nJS.time.formats.aux)._d;

      // CASE
      // B inizia in A
      // A_start ----- B_start ----- A_end ----- B_end
      //
      // B finisce in A
      // B_start ----- A_start ----- B_end ----- A_end
      //
      // A è in B
      // B_start ----- A_start ----- A_end ----- B_end
      //

      if (a_start < b_start && b_start < a_end) return true; // B inizia in A
      if (a_start < b_end && b_end < a_end) return true; // B finisce in A
      if (b_start < a_start && a_end < b_end) return true; // A è in B

      return false;
    },
    compareOverlapse(activity) {
      if (this.invalidActivitiesGroups.length < 1) return; // NON ci sono dati comparativi

      activity.domestic_activity_save = true;
      this.invalidActivities.pop(activity.domestic_activity_id);

      var sliced = [];

      this.invalidActivitiesGroups.forEach((target) => {
        if (activity.domestic_activity_id === target[0]) {
          sliced.push(this.slicedDomesticActivities.find((activitySub) => activitySub.domestic_activity_id === target[1]));
        } else if (activity.domestic_activity_id === target[1]) {
          sliced.push(this.slicedDomesticActivities.find((activitySub) => activitySub.domestic_activity_id === target[0]));
        }
      });

      if (sliced.length < 1) return;

      sliced.forEach((compareActivity) => {
        if (activity.domestic_activity_user_id !== compareActivity.domestic_activity_user_id) return;
        if (activity.domestic_activity_id === compareActivity.domestic_activity_id) return;

        if (this.overlaps(activity, compareActivity)) {
          activity.domestic_activity_save = false;
          this.slicedDomesticActivities.forEach((activitySub) => {
            if (activitySub.domestic_activity_id === compareActivity.domestic_activity_id) {
              activitySub.domestic_activity_save = false;
            }
          });
        } else {
          this.invalidActivities = this.invalidActivities.filter((invalidActivity) => {
            invalidActivity !== activity.domestic_activity_id && invalidActivity !== compareActivity.domestic_activity_id;
          });
        }
      });
    },
    findParallelActivities() {
      if (this.slicedDomesticActivities.length <= 1) return;

      var reverseSlicedDomesticActivities = this.slicedDomesticActivities.slice().reverse();
      this.slicedDomesticActivities.forEach((activity) => {
        reverseSlicedDomesticActivities.forEach((compareActivity) => {
          if (activity.domestic_activity_user_id !== compareActivity.domestic_activity_user_id) return;
          if (activity.domestic_activity_id === compareActivity.domestic_activity_id) return;

          if (this.overlaps(activity, compareActivity)) {
            this.invalidActivities.push(activity.domestic_activity_id, compareActivity.domestic_activity_id);
            this.invalidActivitiesGroups.push([activity.domestic_activity_id, compareActivity.domestic_activity_id]);

            activity.domestic_activity_save = false;
            compareActivity.domestic_activity_save = false;
          }
        });
      });
    },
    validateActivities() {
      if (this.disable_parallel_activity_execution_on_operator === 'true') {
        this.findParallelActivities();
        if (!this.overlappingActivitiesExist) {
          this.saveActivities();
        } else {
          this.overlapseAlertText = 'Impossibile salvare le attività, attività concorrenti presenti';
        }
      } else {
        this.saveActivities();
      }
    },
    async loadMotivations(activity) {
      if (activity.domestic_activity_act_conf_id) {
        await apiConnector()
          .get('/it/activities_configs/get_motivations_from_activity.json', {
            params: {
              activity_id: activity.domestic_activity_act_conf_id,
            },
          })
          .then(({ data }) => {
            activity.domestic_activity_motivations.splice(0, activity.domestic_activity_motivations.length);

            data.forEach((activityConfig) => {
              if (activityConfig.motivation) {
                for (let m in activityConfig.motivation) {
                  activity.domestic_activity_motivations.push([activityConfig.motivation[m].desc, activityConfig.motivation[m].cod]);
                }
              }
            });
          })
          .catch((err) => {
            console.error('Error on loadMotivations', err);
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.input_date {
  margin-bottom: 0;
}

input[type='number'] {
  width: 50px;
}

.vmodal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  left: 10%;
  width: 80%;
  margin-left: 0;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #eeeeee;
  color: #ef7b12;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  border: none;
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #ef7b12;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

#no-visit {
  text-align: center;
  margin-top: 7%;
}

.graycolor {
  color: #999;
}

.blackcolor {
  color: #0000;
}

.km_rimborso {
  margin-top: 5px;
  margin-bottom: 0;
  margin-left: 6px;
}

.span-error {
  font-size: 13px;
  color: red;
  margin-left: 29px;
}
</style>
